export default key => (total, element) => total + element[key];